import { KEY_CODES } from "../../../gearshiftGame/constants";

// Matches gf_gym_agents' press_key_N action space (no lane 4, the center lane).
const LANE_TO_CODE = Object.fromEntries(Object.entries(KEY_CODES).map(([code, lane]) => [lane, code]));

// Non-lane keys the game also listens for; Space doubles as proximity lock-on and HQ "continue".
const ACTION_KEYS = {
  Space: "proximity lock-on / HQ message continue",
  KeyZ: "brake",
  Slash: "accelerate",
};

function dispatchKeyEvent(type, code) {
  document.dispatchEvent(new KeyboardEvent(type, { code, bubbles: true, cancelable: true }));
}

/**
 * Dispatches a real keydown/keyup on `document`, same path a human keypress takes.
 * @param {string} code A DOM `event.code` value from KEY_CODES (e.g. "KeyS") or ACTION_KEYS (e.g. "Space")
 * @param {{holdMs?: number, decisionId?: string, session?: object, decisionLatencyMs?: number, gameStateAtDecision?: object}} [options]
 */
export function pressKey(
  code,
  { holdMs = 60, decisionId = null, session = null, decisionLatencyMs = null, gameStateAtDecision = null } = {}
) {
  const isLaneKey = Object.prototype.hasOwnProperty.call(KEY_CODES, code);
  const isActionKey = Object.prototype.hasOwnProperty.call(ACTION_KEYS, code);
  if (!isLaneKey && !isActionKey) {
    const validCodes = [...Object.keys(KEY_CODES), ...Object.keys(ACTION_KEYS)];
    throw new Error(`[aiAgent] "${code}" is not a valid key (${validCodes.join(", ")})`);
  }

  console.log("[aiAgent] action", {
    decisionId,
    agentId: session?.agentId ?? null,
    agentRunId: session?.agentRunId ?? null,
    code,
    decisionLatencyMs,
    gameStateAtDecision,
    timestamp: Math.round(performance.now()),
  });

  dispatchKeyEvent("keydown", code);
  window.setTimeout(() => dispatchKeyEvent("keyup", code), holdMs);
}

/**
 * Same as pressKey, but by lane number.
 * @param {number} lane
 * @param {Parameters<typeof pressKey>[1]} [options]
 */
export function pressLane(lane, options) {
  const code = LANE_TO_CODE[lane];
  if (!code) {
    throw new Error(`[aiAgent] "${lane}" is not a valid lane (${Object.keys(LANE_TO_CODE).join(", ")})`);
  }
  pressKey(code, options);
}

/**
 * Presses Space - proximity lock-on, or dismisses an HQ message. Safe to call speculatively.
 * @param {Parameters<typeof pressKey>[1]} [options]
 */
export function pressSpace(options) {
  pressKey("Space", options);
}
